import mark from "@/assets/villaflow-mark.png";

// Official VillaFlow logo (transparent mark extracted from the supplied artwork — never redrawn).
// variant "full" includes the "EVERY STAY. MORE VALUE." tagline; "wordmark" crops it for tight spaces.
export default function Logo({ className = "h-16", variant = "full" }) {
  if (variant === "wordmark") {
    return (
      <span
        className={`inline-block overflow-hidden ${className}`}
        style={{ aspectRatio: "842 / 268" }}
        data-testid="villaflow-logo"
      >
        <img src={mark} alt="VillaFlow" className="w-full h-auto select-none" draggable={false} />
      </span>
    );
  }
  return (
    <img
      src={mark}
      alt="VillaFlow — Every Stay. More Value."
      className={`${className} w-auto select-none`}
      draggable={false}
      data-testid="villaflow-logo"
    />
  );
}
